import React, { useEffect, useRef, useState } from 'react';
import Table from './Table';
import Cart from './Cart';
import { Routes, Route } from 'react-router-dom'; // Remove BrowserRouter as Router
import OrderSummary from './OrderSummary';
import About from './About';
import Products from './Products';
import Offers from './Offers';
import Contact from './Contact';
import Login from './Login';
import Admin from './Admin';

// Sparkle component for left/right, lightweight and performant
const Sparkle = ({ position = 'left' }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let sparks = [];
    let animationFrameId;

    function randomBetween(a, b) {
      return a + Math.random() * (b - a);
    }

    function createSpark() {
      // Only 1-2 sparks per frame for performance
      for (let i = 0; i < 2; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = randomBetween(1, 2.2);
        sparks.push({
          x: 30,
          y: 100,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          radius: randomBetween(1, 2),
          color: '#FFD700',
          alpha: 1
        });
      }
    }

    function animate() {
      ctx.clearRect(0, 0, 60, 120);
      createSpark();
      sparks.forEach((s) => {
        ctx.save();
        ctx.globalAlpha = s.alpha;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.radius, 0, Math.PI * 2);
        ctx.fillStyle = s.color;
        ctx.shadowColor = s.color;
        ctx.shadowBlur = 8;
        ctx.fill();
        ctx.restore();

        s.x += s.vx;
        s.y += s.vy;
        s.vx *= 0.95;
        s.vy *= 0.95;
        s.alpha -= 0.03;
      });
      sparks = sparks.filter(s => s.alpha > 0.1);
      animationFrameId = requestAnimationFrame(animate);
    }

    animate();
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      width={60}
      height={120}
      style={{
        position: 'absolute',
        [position]: 40,
        top: 80,
        zIndex: 2,
        pointerEvents: 'none'
      }}
    />
  );
};

const Layout = ({ onScroll }) => {
  const [cartCount,setCartCount] = useState(0);

  useEffect(() => {
    // Sync cart count with localStorage
    const updateCartCount = () => {
      const storedCart = JSON.parse(localStorage.getItem('cartProducts') || '[]');
      setCartCount(storedCart.length);
    };
    console.log('localStorage', cartCount?.length);
    updateCartCount();
    window.addEventListener('storage', updateCartCount);
    return () => window.removeEventListener('storage', updateCartCount);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (onScroll) {
        onScroll(window.scrollY > 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [onScroll]);

  return (
    <div>
      <header
        style={{
          padding: 0,
          textAlign: 'center',
          backgroundColor: '#222',
          position: 'relative',
          minHeight: '180px',
          height: '28vw',
          backgroundImage: 'url("/images/online-crackers-header.jpg")',
          backgroundSize: '100% 100%', // Stretch to fit width and height
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            minHeight: '28vw',
            maxHeight: 400,
            height: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: 'rgba(34,34,34,0.1)'
          }}
        >
          {/* Only 2 sparkles, left and right */}
          <Sparkle position="left" />
          <Sparkle position="right" />
        </div>
      </header>
      <main>
        {/* Remove <Router> here, only use <Routes> and <Route> */}
        <Routes>
          <Route path="/" element={<Table />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/order-summary" element={<OrderSummary />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      <footer>
        <p>Copyright © 2025, Online Crackers Designed By KKK Pvt Ltd., Sivakasi</p>
      </footer>
    </div>
  );
};

export default Layout;